<template>
  <div id="list">
    <div role="tablist" v-if="networksArray">
      <b-card no-body class="mb-1" v-for="item in networksArray" :key="item.id" :ref="item.id" @click="showMeICon(item)" >
        
        <b-card-header header-tag="header" class="p-1" role="tab" open-collapsible >    
          <b-button block href="#" v-b-toggle="item.id" variant="info">{{ item.fields.name }}</b-button>
        </b-card-header>
        
        <b-collapse :id="item.id" accordion="my-accordion" role="tabpanel">
        
          <b-card-body>
            <a v-if="item.fields.url" :href="item.fields.url">URL</a> 
            <b-card-text>
              
              <p v-if="item.fields.cityName"> City: {{ item.fields.cityName }} </p>
              <p v-if="item.fields.type"> Type: {{ item.fields.type }} </p>
              <p v-if="item.fields.status"> Status: {{ item.fields.status }}</p>
              <p v-if="item.fields.yearFunded"> Status: {{ item.fields.yearFunded }}</p>
              
              <strong v-if="item.fields.relatedProgram"> Related Programs</strong>
              <ul v-if="item.fields.relatedProgramNames">
                <li v-for="program in item.fields.relatedProgramNames.split(',')" :key="program">  {{ program }} </li>
              </ul>
             
              <strong v-if="item.fields.DonorsNames"> Related Funds</strong>
              <ul v-if="item.fields.DonorsNames">
                <li v-for="donors in item.fields.DonorsNames.split(',')" :key="donors">  {{ donors }} </li>
              </ul>

              <strong> Country </strong> <b-button id="show-btn" @click="updateCountry(item.fields.countryID)" v-b-modal.bv-modal>{{ item.fields.countryName }}</b-button>
                
            </b-card-text>
          </b-card-body>
     
        </b-collapse>
      </b-card>
    </div>
    <CountryModal :country="activeCountry"/>
  </div>
</template>

<script>
import CountryModal from './CountryModal'
import { cases } from "../shared";
import { serviceBus } from "../main"

export default {
  name: "Infocard",
  components: {
    CountryModal,
  },
  props: {
    networksArray: Array, 
    countriesObj: Object
  },
  data: function() {
    return {
      activeCountry: {name:"country"}
    };
  },
  mounted: function() {},
  watch:{
    locationChanged(){
      this.$root.$emit('bv::toggle::collapse', this.$store.getters.getNetworks[0]); //open collapsible
      this.$refs[this.$store.getters.getNetworks[0]][0].scrollIntoView(true); //scroll 
    },
  },
  created(){  },
  computed: {
    locationChanged(){
      return this.$store.getters.getNetworks;
    }
  },
  methods: {
    showMeICon(item){
      // location actual, ID del nuevo item location
      item.fields.cityID != undefined ? serviceBus.$emit('cardClicked', item.fields.cityID[0]) : console.log("no city")
    },
    updateCountry(id){
      console.log(this.countriesObj, id[0])
      this.activeCountry = this.countriesObj[id[0]];
    }
  }
};
</script>

<style lang="scss" scoped>
#list {
  height: 90vh;
  width: 19vw;
  float: right;
  overflow-y: auto;
}

.mb-1, .my-1 {
    margin-bottom: 0 !important;
}
.card-header {
    border-bottom: 0 !important;
}

.p-1 {
    padding: 0.5px !important;
}

.card{
  background: #f3f0ea;
  border: 1.5px solid #2c2f30;
  border-radius: 0;
}

.btn-info, .btn-info:hover {
    background-color: #4a9cd2 !important;
    border-color: #4a9cd2 !important;
}

 .card-body > a{
    position: absolute;
    right: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    text-align: center;
    background: #2c2f30 !important;
    padding: 1px;
    color: #e43e74;
}
.btn-secondary {
    color: #e43e74 !important;
    background-color: transparent !important;
    border-color: transparent !important;
}

</style>